export const LOAD_CONSENTS_REQUEST = 'LOAD_CONSENTS_REQUEST';
export const LOAD_CONSENTS_SUCCESS = 'LOAD_CONSENTS_SUCCESS';
export const LOAD_CONSENTS_FAILURE = 'LOAD_CONSENTS_FAILURE';

export const UPDATE_CONSENTS_REQUEST = 'UPDATE_CONSENTS_REQUEST';
export const UPDATE_CONSENTS_SUCCESS = 'UPDATE_CONSENTS_SUCCESS';
export const UPDATE_CONSENTS_FAILURE = 'UPDATE_CONSENTS_FAILURE';
